var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"primary",attrs:{"small":"","disabled":_vm.disabled,"color":"success"},on:{"click":_vm.buildReport}},[_c('v-icon',{staticClass:"mr-2",attrs:{"medium":""}},[_vm._v("mdi-microsoft-excel")]),_c('span',{staticClass:"pr-1"},[_vm._v("Create excel")])],1),_c('lin_prg_bar',{ref:"prgbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }